module.exports = __webpack_public_path__ + "media/images/result_sets/circles/5r4n8r7r-1f5fd107cea0ffb608d92d6db5449869.svg";